module.exports = __webpack_public_path__ + "img/error.0e9d67aa.svg";